"use strict";
/**
 * Created by rouven on 03.03.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
require("react-select/dist/react-select.css");
require("react-virtualized/styles.css");
require("react-virtualized-select/styles.css");
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_virtualized_select_1 = __importDefault(require("react-virtualized-select"));
var stringifyValue_1 = __importDefault(require("../../helpers/stringifyValue"));
var VirtualizedSelectInput = function (props) {
    var value = (0, stringifyValue_1["default"])(props.input.value);
    // @ts-ignore
    return react_1["default"].createElement(react_virtualized_select_1["default"], __assign({}, props, { value: value, onChange: function (selected) { return props.input.onChange(
        //  @ts-ignore
        selected != null && selected.hasOwnProperty('value') ? selected.value : null); }, onBlur: function () { return props.input.onBlur(value); }, disabled: props.readOnly || props.disabled }));
};
VirtualizedSelectInput.propTypes = {
    input: prop_types_1["default"].object,
    options: prop_types_1["default"].array,
    placeholder: prop_types_1["default"].node
};
exports["default"] = VirtualizedSelectInput;
